export default {
  error: {
    trace: 'Nachverfolgung: {n}',
    api: {
      response: 'Es gab ein Problem mit der Serverantwort'
    },
    pin: {
      'INVALID-PIN-LENGTH': 'Die PIN hatte nicht die richtige Länge',
      'INVALID-PIN': 'Es wurde eine ungültige PIN bereitgestellt',
      'NO-TRANSACTION-DATA': 'Keine Transaktionsdaten für die PIN verfügbar',
      'NO-ACCOUNT': 'Es wurde eine ungültige PIN bereitgestellt (Fehler: 1)',
      'NO-BRANCH': 'Es wurde eine ungültige PIN bereitgestellt (Fehler: 2)',
      'NO-COMPANY': 'Es wurde eine ungültige PIN bereitgestellt (Fehler: 3)'
    },
    tableNumber: {
      'INVALID-PIN-LENGTH': 'Die Tischnummer hatte nicht die richtige Länge',
      'INVALID-PIN': 'Es wurde eine ungültige Tischnummer bereitgestellt',
      'NO-TRANSACTION-DATA': 'Keine Transaktionsdaten für die Tischnummer verfügbar',
      'NO-ACCOUNT': 'Es wurde eine ungültige Tischnummer bereitgestellt (Fehler: 1)',
      'NO-BRANCH': 'Es wurde eine ungültige Tischnummer bereitgestellt (Fehler: 2)',
      'NO-COMPANY': 'Es wurde eine ungültige Tischnummer bereitgestellt (Fehler: 3)'
    }
  }
};